import * as React from 'react';
import Backdrop from '@mui/material/Backdrop';
import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import Fade from '@mui/material/Fade';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import { getHeaderImage } from '../../../redux/actions/addCampaigndata';
import { useSelector, useDispatch } from 'react-redux';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import { Toastify } from "../../../services/toastify/toastifyContainer";
import stylse from './modal.module.css'


const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    maxWidth: '100%',
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
    border: 'none',
    borderRadius: "10px"
};

export default function 
ImageModal({ open, handleClose, handleUrlChanges, }) {
    const images = useSelector(state => state.addCampaignReducer.imagesFetch); // Assuming images are stored in imagesFetch

    const dispatch = useDispatch();
 
    let keys = localStorage.getItem("key");

    React.useEffect(() => {
        if (open) {
            dispatch(getHeaderImage());
        }
    }, [open, dispatch]);

 

    
    const copyImageUrl = (url) => {
    
        
        if (keys == "left_nav_logo") {
            handleUrlChanges('left_nav_logo', url)
          
        }
        if (keys == "nav_right_logo") {
            handleUrlChanges('nav_right_logo', url)
        }
        if (keys == "share_image") {
            handleUrlChanges('share_image', url)
        }
        if (keys == "favicon") {
            handleUrlChanges('favicon', url)
        }
        navigator.clipboard.writeText(url)
            .then(() => Toastify({ data: "success", msg: 'Image URL copied to clipboard' }))
            .catch((error) => console.error('Error copying URL to clipboard:', error));

    };

    return (
        <div>
            <Modal
                aria-labelledby="transition-modal-title"
                aria-describedby="transition-modal-description"
                open={open}
                onClose={handleClose}
                closeAfterTransition
                slots={{ backdrop: Backdrop }}
                slotProps={{
                    backdrop: {
                        timeout: 500,
                    },
                }}
            >
                <Fade in={open}>
                    <Box sx={style}>
                        <Typography id="transition-modal-title" variant="h6" component="h2">
                            Select Your Images <span className='text-warning'>{keys}</span>
                        </Typography>
                        <div className=' '>
                            {keys === 'share_image' && images['share_images'] && (
                                <div className="d-flex flex-wrap gap-1" style={{ scrollBehavior: "smooth", height: "300px", width: "100%", overflowY: "auto", marginTop: "10px" }}>
                                    {images['share_images'].map((image, index) => (
                                        <div key={image.id}>
                                            <img
                                                src={image}
                                                alt="image"
                                                style={{ width: "100px", padding: "10px", cursor: 'pointer', border: "1px solid black", borderRadius: "10px" }}
                                                onClick={() => copyImageUrl(image)}
                                            />
                                        </div>
                                    ))}
                                </div>
                            )}
                            {keys === 'left_nav_logo' && images['left_nav_logos'] && (
                                <div className="d-flex flex-wrap gap-1" style={{ scrollBehavior: "smooth", height: "300px", width: "100%", overflowY: "auto", marginTop: "10px" }}>
                                    {images['left_nav_logos'].map((image, index) => (
                                        <div key={image.id}>
                                            <img
                                                src={image}
                                                alt="image"
                                                style={{ width: "100px", padding: "10px", cursor: 'pointer', border: "1px solid black", borderRadius: "10px" }}
                                                onClick={() => copyImageUrl(image)}
                                            />
                                        </div>
                                    ))}
                                </div>
                            )}
                            {keys === 'nav_right_logo' && images['nav_right_logos'] && (
                                <div className="d-flex flex-wrap gap-1" style={{ scrollBehavior: "smooth", height: "300px", width: "100%", overflowY: "auto", marginTop: "10px" }}>
                                    {images['nav_right_logos']?.map((image, index) => (
                                        <div key={image?.id}>
                                            <img
                                                src={image}
                                                alt="image"
                                                style={{ width: "100px", padding: "10px", cursor: 'pointer', border: "1px solid black", borderRadius: "10px" }}
                                                onClick={() => copyImageUrl(image)}
                                            />
                                        </div>
                                    ))}
                                </div>
                            )}
                            {keys === 'favicon' && images['favicons'] && (
                                <div className="d-flex flex-wrap gap-1" style={{ scrollBehavior: "smooth", height: "300px", width: "100%", overflowY: "auto", marginTop: "10px" }}>
                                    {images['favicons']?.map((image, index) => (
                                        <div key={image?.id}>
                                            <img
                                                src={image}
                                                alt="image"
                                                style={{ width: "100px", padding: "10px", cursor: 'pointer', border: "1px solid black", borderRadius: "10px" }}
                                                onClick={() => copyImageUrl(image)}
                                            />
                                        </div>
                                    ))}
                                </div>
                            )}
                        </div>
                    </Box>
                </Fade>
            </Modal>
        </div>
    );
}
